import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import API from '../../../create/api';
import { Pagination } from '@mui/material';
import moment from 'moment';
const MyTable = () => {
  const [data, setData]: any = useState([]);
  const [page, setPage]: [number, any] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      const _limit = 10;
      const start = (page - 1) * _limit;
      const userLogs: any = await API.getAll(
        `${process.env.REACT_APP_API_SERVER}/parcel-logs?_start=${start}&_limit=${_limit}&_sort=created_at:DESC`,
      );
      setData(userLogs);
    };
    fetchData();
  }, [page]);

  const handlePageChange = (event: any, value: number) => {
    setPage(value);
  };

  return (
    <div>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>User Id</TableCell>
            <TableCell>Change</TableCell>
            <TableCell>Time</TableCell>
          </TableRow>
          {data.map((item: any, index: number) => (
            <TableRow key={index}>
              <TableCell>{JSON.stringify(item?.user?.id)}</TableCell>
              <TableCell>
                {item?.user?.username ?? ''} {item.type} Parcel: {item.parcel_id ?? ''}
              </TableCell>
              <TableCell>
                {moment(moment()).diff(item.created_at, 'days') > 1
                  ? moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')
                  : moment(item.created_at).fromNow()}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Pagination page={page} count={10} onChange={handlePageChange} />
    </div>
  );
};

export default MyTable;
